import {
    ApplicationConfig,
    importProvidersFrom,
} from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';

import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MockApiService } from 'app/mock-api';
import { QueriesService } from './services/queries.service';
import { appRoutes } from 'app/app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAuth } from 'app/core/auth/auth.provider';
import { provideFuse } from '@fuse';
import { provideHttpClient } from '@angular/common/http';
import { provideIcons } from 'app/core/icons/icons.provider';

export const appConfig: ApplicationConfig = {
    providers: [
        QueriesService,
        importProvidersFrom(MatSnackBarModule),
        provideAnimations(),
        provideHttpClient(),
        provideRouter(appRoutes,
            withPreloading(PreloadAllModules),
            withInMemoryScrolling({scrollPositionRestoration: 'enabled'}),
        ),

        // Material Date Adapter
        {
            provide: DateAdapter,
            useClass: LuxonDateAdapter,
        },
        {
            provide : MAT_DATE_FORMATS,
            useValue: {
                parse  : {
                    dateInput: 'dd-MM-yyyy',
                },
                display: {
                    dateInput         : 'yyyy-MM-dd',
                    monthYearLabel    : 'MMM yyyy',
                    dateA11yLabel     : 'LL',
                    monthYearA11yLabel: 'MMMM yyyy',
                },
            },
        },
        {
            provide: MatPaginatorIntl,
        },

        // Fuse
        provideAuth(),
        provideIcons(),
        provideFuse({
            mockApi: {
                delay: 0,
                service: MockApiService,
            },
            fuse   : {
                layout : 'modern',
                scheme : 'light',
                screens: {
                    sm: '600px',
                    md: '960px',
                    lg: '1280px',
                    xl: '1440px',
                },
                theme  : 'theme-amber',
                themes : [
                    {
                        id  : 'theme-default',
                        name: 'Default',
                    },
                    {
                        id  : 'theme-brand',
                        name: 'Brand',
                    },
                    {
                        id  : 'theme-teal',
                        name: 'Teal',
                    },
                    {
                        id  : 'theme-rose',
                        name: 'Rose',
                    },
                    {
                        id  : 'theme-purple',
                        name: 'Purple',
                    },
                    {
                        id  : 'theme-amber',
                        name: 'Amber',
                    },
                ],
            },
        }),
    ],
};
